import React from "react";
import { Button, Grid, Header, Icon } from "semantic-ui-react";
import useCustomerView from "../../hooks/useCustomerView";
import CustomerSessionsTable from "@common/components/shared/CustomerReview/CustomerSessionsTable";
import CustomerReviewFiltersDesktop from "@common/components/shared/CustomerReview/CustomerReviewFiltersDesktop";
import useCustomerReviewsFilters from "@common/components/hooks/useCustomerReviewsFilters";

const CustomerSessions = () => {
  const { linkedSessionsColumns, customerSessions, fullName } =
    useCustomerView();
  const { showFilters, toggleFilters } = useCustomerReviewsFilters();

  return (
    <Grid className="pt-1 w-100">
      <Grid.Row className="flex-row-center">
        <Header className="pt-1 pl-1">{fullName} - Linked Sessions</Header>
        <Button
          type="button"
          onClick={toggleFilters}
          color={showFilters ? "black" : ""}
          inverted={!showFilters}
          className="w-3 h-3 p-0 m-0 border"
        >
          <Icon
            style={{ padding: "0 0 0 0.35em" }}
            name="sliders horizontal"
            color={showFilters ? "" : "black"}
            size="large"
          />
        </Button>
      </Grid.Row>
      <CustomerReviewFiltersDesktop />
      <CustomerSessionsTable
        headings={linkedSessionsColumns}
        records={customerSessions}
      />
    </Grid>
  );
};
export default CustomerSessions;
